module.exports = __webpack_public_path__ + "img/content-save-outline.33b072c6.svg";